import React from "react";
import PropTypes from "prop-types";
import SimpleErrorBoundary from "widgets/SimpleErrorBoundary";
import { buildList } from "./utils";
import ActionSubMenu from "./ActionSubMenu";
import Menu from "./Menu";
import Portal from "./Portal";
import Trigger from "./Trigger";
import BasicAction from "./BasicAction";
import LinkAction from "./LinkAction";

import "./ActionMenu.css";

let menuIndex = 1;

export default function ActionMenu({
	actionLists,
	icon,
	actionContext,
	className,
	isDisabled,
	isMultiLine,
	tooltipContent,
	menuClass }){
	let id = menuIndex;
	menuIndex = menuIndex + 1;
	let [menuItems, hasItems] = buildList(actionLists, actionContext);


	// Don't display the trigger or anything if there are no displayable actions.
	if(!hasItems){
		return null;
	}

	return (
		<div className={`action-menu ${className}`} data-multiline={isMultiLine} data-tip={tooltipContent}>
			<Trigger id={id} icon={icon} isDisabled={isDisabled}  />
			<Portal>
				<SimpleErrorBoundary>
					<Menu
						id = {id}
						menuItems = {menuItems}
						menuClass = {menuClass}
					/>
				</SimpleErrorBoundary>
			</Portal>
		</div>
	);
}

ActionMenu.displayName = "ActionMenu";
ActionMenu.defaultProps = {
	actionLists:    [],
	icon:           "moreHorizontal",
	actionContext:  {},
	className:      "",
	isDisabled:     false,
	isMultiLine:    false,
	tooltipContent: "",
	menuClass:      "",
};
ActionMenu.propTypes = {
	actionLists:    PropTypes.array,
	icon:           PropTypes.string,
	actionContext:  PropTypes.object,
	className:      PropTypes.string,
	isDisabled:     PropTypes.bool,
	isMultiLine:    PropTypes.bool,
	tooltipContent: PropTypes.string,
	menuClass:      PropTypes.string,
};

export { ActionSubMenu as ActionSubMenu };
export { Menu as Menu };
export { Portal as Portal };
export { Trigger as Trigger };
export { BasicAction as BasicAction };
export { LinkAction as LinkAction };
